module.exports = __webpack_public_path__ + "static/media/VeryHappy.d42f85d4.png";